<template>
    <div>
        <div id="FloorBannerPage">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide>
                    <FloorFirst></FloorFirst>
                </swiper-slide>
                <swiper-slide>
                    <FloorSecond></FloorSecond>
                </swiper-slide>
                <swiper-slide>
                    <FloorThree></FloorThree>
                </swiper-slide>
                <swiper-slide>
                    <FloorFourth></FloorFourth>
                </swiper-slide>
                <swiper-slide>
                    <FloorFifth></FloorFifth>
                </swiper-slide>
                <swiper-slide>
                    <FloorSix></FloorSix>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <div class="mouse_bigbox">
                <div class="mouse_box">
                    <div class="dian"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FloorFirst from "../../components/FloorHome/first";
    import FloorSecond from "../../components/FloorHome/second";
    import FloorThree from "../../components/FloorHome/three";
    import FloorFourth from "../../components/FloorHome/fourth";
    import FloorFifth from "../../components/FloorHome/fifth";
    import FloorSix from "../../components/FloorHome/six";

    export default {
        name: "",
        props: {},
        components: {
            FloorFirst,
            FloorSecond,
            FloorThree,
            FloorFourth,
            FloorFifth,
            FloorSix,
        },
        data() {
            return {
                swiperOption: {
                    slidesPerView: 1,
                    mousewheel: true,
                    direction: "vertical",
                    autoHeight: true,
                    height: window.innerHeight,
                    speed: 800,
                    simulateTouch: false,
                    pagination: {
                        //分页容器的css选择器
                        el: ".swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            var text = "";
                            switch (index) {
                                case 0:
                                    text = "ONE";
                                    break;
                                case 1:
                                    text = "TWO";
                                    break;
                                case 2:
                                    text = "THREE";
                                    break;
                                case 3:
                                    text = "FOUR";
                                    break;
                                case 4:
                                    text = "FIVE";
                                    break;
                                case 5:
                                    text = "SIX";
                                    break;
                            }
                            return (
                                '<li class=" ' +
                                className +
                                '">' +
                                `<span class="swiperspan"> ${text}</span><span class="top">▲</span><span class="dian"></span><span class="bottom">▼</span>` +
                                "</li>"
                            );
                        },
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    on: {
                        slideChangeTransitionStart: function() {},
                    },
                },
                // floorArr:[],
                activeIndex: 0,
            };
        },
    };
</script>

<style scoped lang='scss'>
    #FloorBannerPage {
        width: 100%;

        .mouse_bigbox {
            width: 100vw;
            position: fixed;
            bottom: 4vh;
            z-index: 99;
            display: flex;
            justify-content: center;

            .mouse_box {
                width: 22px;
                height: 3vh;
                background-image: url("../../assets/components_img/mouse.png");
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                z-index: 99;

                .dian {
                    width: 3px;
                    height: 6px;
                    margin-top: 6px;
                    background: #ffffff;
                    border-radius: 1px;
                    animation: myfirstjt 1s linear infinite;
                }

                @keyframes myfirstjt {
                    0% {
                        transform: translateY(0px);
                    }

                    50% {
                        transform: translateY(4px);
                    }

                    100% {
                        transform: translateY(0px);
                    }
                }
            }
        }
    }
</style>
